import { CONFIGURATION_APIS } from "@/api_framework/api_config";
import { IConfigurationStaffListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setStaffList } from "@/app_redux/reducers/slices/auth/configuration_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useCurlLogger } from "../../useCurlLogger";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});
export const useConfigurationFilterStaffListAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (
      city_id: string,
      category_id: string,
      role_id: string,
      page_number?: number,
      page_size?: number,
      search_keyword?: string,
    ) => {
      dispatch(
        setLoading({
          key: "isOnboardStaffListInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const params = new URLSearchParams({
          city_id,
          category_id,
          role_id,
        });
        if (page_number !== undefined) params.append("page_number", String(page_number));
        if (page_size !== undefined) params.append("page_size", String(page_size));
        if (search_keyword) params.append("search_keyword", search_keyword);
        await axios
          .get(`${CONFIGURATION_APIS?.STAFF_CATEGORY_FILTER?.baseURL}?${params.toString()}`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IConfigurationStaffListResponse>) => {
            dispatch(
              setLoading({
                key: "isOnboardStaffListInProgress",
                status: false,
              }),
            );
            if (res.data.status === true) {
              dispatch(
                setStaffList({
                  data: res.data.data,
                }),
              );
            } else {
              toast.error("Error while fetching staff list.");
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
          });
      } catch (error) {
        dispatch(
          setLoading({
            key: "isOnboardStaffListInProgress",
            status: false,
          }),
        );
        if (axios.isAxiosError(error)) {
          const axiosError = error as AxiosError;
          if (axiosError.code === "ERR_BAD_REQUEST") {
            toast.error("Error at server while fetching staff category details.");
          }
          if (axiosError.response?.status === 400) {
            toast.error(axiosError.message);
          }
          if (axiosError.response?.status === 500) {
            toast.error("Internal Server Error, Contact Tech Team.");
          }
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [dispatch, configuration],
  );

  return execute;
};